import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import type { StoredStats } from '../types'
import { formatPrice, formatSeconds } from '../format'
import { TV_COLORS, neonText } from '../designSystem'

type ScorePanelProps = {
  stats: StoredStats
}

const ScorePanel = ({ stats }: ScorePanelProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: 2,
        padding: 1.2,
        background: 'linear-gradient(180deg, rgba(18,18,18,0.9), rgba(0,0,0,0.8))',
        border: '1px solid rgba(255,255,255,0.12)',
        boxShadow: '0 0 14px rgba(0,0,0,0.45)',
        color: '#fff',
        minHeight: 0,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ fontFamily: 'Bebas Neue', fontSize: 26, mb: 2, ...neonText(TV_COLORS.cyan) }}
      >
        Panneau des records
      </Typography>

      <Stack spacing={2}>
        <Box>
          <Typography variant="caption" sx={{ textTransform: 'uppercase', opacity: 0.7 }}>
            Meilleure série
          </Typography>
          <Typography variant="h4" sx={{ fontFamily: 'Orbitron', color: TV_COLORS.yellow }}>
            {stats.bestQualificationStreak}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" sx={{ textTransform: 'uppercase', opacity: 0.7 }}>
            Record temps final
          </Typography>
          <Typography variant="h5" sx={{ fontFamily: 'Orbitron', color: TV_COLORS.cyan }}>
            {stats.bestFinalTimeMs ? formatSeconds(stats.bestFinalTimeMs) : '--:--'}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" sx={{ textTransform: 'uppercase', opacity: 0.7 }}>
            Dernière victoire
          </Typography>
          {stats.lastVehicleLabel ? (
            <Typography variant="body1" sx={{ fontFamily: 'Montserrat', fontWeight: 600 }}>
              {stats.lastVehicleLabel}
            </Typography>
          ) : (
            <Typography variant="body1">Aucune victoire enregistrée</Typography>
          )}
          {stats.lastVehiclePrice ? (
            <Typography variant="h6" sx={{ fontFamily: 'Orbitron', color: TV_COLORS.yellow }}>
              {formatPrice(stats.lastVehiclePrice)}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Box>
  )
}

export default ScorePanel
